var exports = {
  "Qs": "DomainMovedStepsModal.module__content___NlFtcF",
  "Ci": "DomainMovedStepsModal.module__steps___NlFtcF",
  "PM": "DomainMovedStepsModal.module__step___NlFtcF",
};

module.exports = exports;
